<template>
  <CommonLayout header="floristHeader" footer="floristFooter">
    <div class="container">
      <div class="row justify-content-center align-items-center mh-100vh">
        <div class="col-md-8 text-center">
          <h2>ミーティング情報が取得できませんでした。<br>もう一度ログインしてください。</h2>
        </div>
      </div>
    </div>
  </CommonLayout>
</template>
<script>
import CommonLayout from '@/layout/CommonLayout'

export default {
  name: 'FloristMeetingError',
  components: {CommonLayout}
}
</script>



// WEBPACK FOOTER //
// src/pages/FloristMeetingError.vue